import React from 'react';
import './note.css';

// html: false prevents raw HTML in .md files from being injected (XSS fix)
const md = require('markdown-it')({
    html: false
  })
  .use(require('markdown-it-highlightjs'))
  .use(require('markdown-it-katex'))

export default class Note extends React.Component {

    constructor(props){
        super(props)
        this.state ={
            bodytxt:"Loading..",
            filename:props.name
        }
    }

    componentDidMount() {
        const readmePath = require(`../notes/${this.state.filename}.md`);
        fetch(readmePath )
          .then(response => {
            return response.text()
          })
          .then(text => {
            const body = md.render(text)
            this.setState({
              bodytxt: body
            })
          })
    }

    render() {
        return (
            <div>
                <div dangerouslySetInnerHTML={{__html: this.state.bodytxt}} />
            </div>
        )
    }
  }